/* Initials from a display name.
 *
 * **Its own module because a component file may export only a component** — a file exporting both a
 * component and a helper breaks fast refresh, which ESLint flags. That is a build-tool rule with a
 * good side effect here: this is the one piece of the chip with real logic, and separating it makes
 * it testable without rendering anything.
 */

/* At most two, from the first two words. A three-initial monogram at 28px stops being legible, and
 * `display_name` here is a person's name or an opaque subject rather than a company's. */
export function initialsOf(displayName: string): string {
  const words = displayName
    .split(/[\s._@-]+/)
    .filter((word) => word.length > 0)
    /* Leading digits and punctuation are dropped rather than rendered: an initial of `7` from
     * `7476007@example` tells a reader nothing, and the `?` fallback below is more honest. */
    .filter((word) => /\p{L}/u.test(word));

  if (words.length === 0) return '?';
  if (words.length === 1) return (words[0] ?? '').slice(0, 2).toUpperCase();
  return `${(words[0] ?? '').charAt(0)}${(words[1] ?? '').charAt(0)}`.toUpperCase();
}
